module.exports = __webpack_public_path__ + "ac0d814b3e009451f9d81590f87a7a80.svg";